import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=c2c956c0&scoped=true"
import script from "./UploadButton.ts?vue&type=script&lang=ts&external"
export * from "./UploadButton.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c956c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2c956c0')) {
      api.createRecord('c2c956c0', component.options)
    } else {
      api.reload('c2c956c0', component.options)
    }
    module.hot.accept("./UploadButton.vue?vue&type=template&id=c2c956c0&scoped=true", function () {
      api.rerender('c2c956c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Processes/components/details/DocumentsTab/UploadButton/UploadButton.vue"
export default component.exports